import { render, staticRenderFns } from "./shopDetail.vue?vue&type=template&id=1971aa6e&scoped=true&"
import script from "./shopDetail.vue?vue&type=script&lang=js&"
export * from "./shopDetail.vue?vue&type=script&lang=js&"
import style0 from "./shopDetail.vue?vue&type=style&index=0&id=1971aa6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1971aa6e",
  null
  
)

export default component.exports